<template>
  <v-app light>
      <v-layout justify-center align-center>
        <v-flex xs12 sm4>
          <v-form ref="form">
            <v-card class="pa-5 mh-control">
              <v-flex class="ma-2 text-xs-center"><h1>User Authentication</h1></v-flex>
              <v-card-text>
                <v-text-field label="Username" v-model="username" :rules="usernameRules" @keyup="loginEnter" required/>
                <v-text-field label="Password" type="password" v-model="password" :rules="passwordRules" @keyup="loginEnter" required/>
                <v-switch class="f-13px" v-model="rememberMe" label="Remember For 30 Days"/>
                <v-alert :type="message.type==='hide'? undefined : message.type || 'type'" :value="message !== null" :color="message.color"
                         dismissible @input="closeMessage" v-if="message !== null">{{message.message}}</v-alert>
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue lighten-1" large light block @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
  </v-app>
</template>

<script>
export default {
  name: 'login-page',
  props: {
    msg: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      username: '',
      usernameRules: [
        (v) => !!v || 'Username required'
      ],
      password: '',
      passwordRules: [
        (v) => !!v || 'Password required'
      ],
      rememberMe: false,
      message: this.msg
    }
  },
  methods: {
    login (event) {
      const self = this
      this.$store.dispatch('Action/setLoading', true)
      self.$store.dispatch('login', { username: self.username, password: self.password, rememberme: self.rememberMe })
        .then(res => {
          this.$store.dispatch('Action/setLoading', false)
          if (typeof this.$route.query.redirect !== 'undefined') {
            self.$router.push(this.$route.query.redirect)
          } else if (typeof this.$route.params.go !== 'undefined') {
            self.$router.go(this.$route.params.go)
          } else {
            self.$router.replace({name: 'Home'})
          }
        })
        .catch(err => {
          const message = err.response.status === 401
            ? {message: 'Invalid username/password', type: 'error'} : {message: err.message, type: 'error'}
          this.message = message
          this.$store.dispatch('Action/setLoading', false)
        })
    },
    loginEnter (event) {
      if (event.keyCode === 13) {
        this.login(null)
      }
    },
    closeMessage (event) {
      this.message = null
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .mh-control{
      position: absolute;
      height: 100% !important;
      top: 0;
  }
  .mh-control h1{
    font-size: 21px;
  }
  .mh-control .card__title{
    padding-bottom: 0px ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue